<template>
  <span :class="wrapperClasses">
    <i
      class="lp-icon"
      :class="[
        box && 'lp-icon-box',
        name ? `lpi-${name}` : '',
        color && `text-${color}`,
        size && `lpi-${size}`,
      ]"
      :style="{
        'background-color': box && boxColor ? boxColor : '',
      }"
      aria-hidden="true"
    >
      <!-- <slot>{{ name_ ? name : '' }}</slot> -->
      <slot />
    </i>
    <span class="icon-text">{{ name }}</span>
  </span>
</template>

<script setup lang="ts">
import { iconType } from '@/components/icon/iconTypes'
import { computed } from 'vue'
import { colorType } from '@/models/types'

type IconSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'base'

defineOptions({
  name: 'lp-icon',
})

export interface Props {
  name: iconType | null
  color?: colorType
  box?: boolean
  compact?: boolean
  boxColor?: colorType
  roundSize?: string
  size?: IconSizes
}

const props = withDefaults(defineProps<Props>(), {
  name: null,
  color: '',
  box: false,
  boxColor: '',
  roundSize: undefined,
  size: 'sm',
})

const wrapperClasses = computed(() => [
  props.roundSize && `icon-round-${props.roundSize}`,
  props.boxColor && `text-${props.boxColor}`,
  props.compact && `compact`,
])
</script>
<style>
.icon-text {
  /* a generic way to visually hide content while remaining accessible to screen readers (h5bp.com) */
  clip: rect(0 0 0 0);
  overflow: hidden;
  position: absolute;
  height: 0;
  width: 0;
}

.lp-checkbox-label .lp-input-icon-wrapper {
  margin-right: 0;
}
</style>
